import { combineReducers, createStore, applyMiddleware} from 'redux';
import ReduxThunk from 'redux-thunk';
import timeline from "./FJTimeline.reducer";
import exportVideo from "./FJExportVideo.reducer";
import resource from "./FJResource.reducer";
import modal from "./FJModal.reducer";
import media from "./FJMedia.reducer";
import preview from "./FJPreview.reducer";
import recording from "./FJRecording.reducer";
import toolbar from "./FJToolbar.reducer";
import toolbarText from "./FJToolbarText.reducer";
import toolbarVideo from "./FJToolbarVideo.reducer";
import toolbarAudio from "./FJToolbarAudio.reducer";
import toolbarPhoto from "./FJToolbarPhoto.reducer";
import save from "./FJSave.reducer";
import user from "./FJUser.reducer";
import undo from "./FJUndo.reducer";
import copy from "./FJCopy.reducer";
import toolbarBackgroundColor from "./FJToolbarBackgroundColor.reducer";
import toolWidget from "./FJToolbarWidget.reducer";
import toolSvg from "./FJToolbarSvg.reducer";
import toolOverlay from "./FJToolbarOverlay.reducer";
import watermark from "./FJWatermark.reducer";
import font from "./FJFont.reducer";
import documentColor from "./FJDocumentColor.reducer";
import stock from './FJStockVideo.reducer';
import filter from './FJFilter.reducer';
import intro from './FJIntro.reducer';
import payment from './FJPayment.reducer';
import exportPreview from './FJExportPreview.reducer';
import more from './FJMore.reducer';
import cloud from './FJCloud.reducer';

const rootReducer = combineReducers({
  timeline,
  exportVideo,
  resource,
  modal,
  media,
  preview,
  recording,
  toolbar,
  toolbarText,
  toolbarVideo,
  toolbarAudio,
  toolbarPhoto,
  save,
  user,
  undo,
  copy,
  toolbarBackgroundColor,
  toolWidget,
  toolSvg,
  toolOverlay,
  font,
  documentColor,
  watermark,
  filter,
  stock,
  intro,
  payment,
  exportPreview,
  more,
  cloud
});

let store = createStore(rootReducer, applyMiddleware(ReduxThunk));

export default store;
